module.exports = __webpack_public_path__ + "mq.2961b72bb651821517b0.svg";


//////////////////
// WEBPACK FOOTER
// E:/proj/news12/zb-n12/scadmin/client/src/assets/fonts/flag-icon-css/flags/1x1/mq.svg
// module id = ../../../../../src/assets/fonts/flag-icon-css/flags/1x1/mq.svg
// module chunks = styles